import { computed, ref } from 'vue';

export interface OrganisationTypeOption {
  /** Value stored on the organisation; must match a backend organisation type. */
  value: string;
  /** i18n key resolved at render time, so switching language updates the labels. */
  labelKey: string;
  /** The type cannot be changed once the organisation has it, so the field is locked. */
  immutable?: boolean;
  /** i18n key warning what switching an existing organisation to this type does. */
  changeWarningKey?: string;
}

/**
 * Organisation types offered when creating or editing an organisation. Unset by default, which keeps the
 * type a free-text field; an application opts in by registering its own set.
 */
export const organisationTypeOptions = ref<OrganisationTypeOption[] | undefined>(undefined);

export const setOrganisationTypeOptions = (options: OrganisationTypeOption[] | undefined): void => {
  organisationTypeOptions.value = options;
};

const findOption = (type: string | undefined) =>
  type ? organisationTypeOptions.value?.find((option) => option.value === type) : undefined;

/** True when organisations of this type may not change type any more. */
export const useIsImmutableOrganisationType = (type: () => string | undefined) =>
  computed(() => !!findOption(type())?.immutable);
